module.exports = __webpack_public_path__ + "static/handshake-min-43e0959406276c943fd3ae2cb85a77a6.jpeg";